import React from "react";
import "./PopupMensagem.css";

function PopupMensagem({ mensagem, onClose }) {
  const mostrarBotao = !mensagem.startsWith("Dados atualizados");

  return (
    <div className="popup-msg-overlay">
      <div className="popup-msg-box">
        <p>{mensagem}</p>
        {mostrarBotao && (
          <button className="popup-msg-btn" onClick={onClose}>
            Confirmar
          </button>
        )}
      </div>
    </div>
  );
}

export default PopupMensagem;